import { render } from "./FacultyCoursesSummary.vue?vue&type=template&id=196b4b3c&scoped=true"
import script from "./FacultyCoursesSummary.vue?vue&type=script&lang=js"
export * from "./FacultyCoursesSummary.vue?vue&type=script&lang=js"

import "./FacultyCoursesSummary.vue?vue&type=style&index=0&id=196b4b3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-196b4b3c"

export default script